module.exports = "pegasus/assets/themelp1/small/6.png";